module.exports = __webpack_public_path__ + "img/s-4.783ba179.jpg";